/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  DeleteApiSocietaSocietaidSmtpConfigurationMutationResponse,
  DeleteApiSocietaSocietaidSmtpConfigurationPathParams,
} from '../models/DeleteApiSocietaSocietaidSmtpConfiguration.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { deleteApiSocietaSocietaidSmtpConfigurationMutationResponseSchema } from '../zod/deleteApiSocietaSocietaidSmtpConfigurationSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const deleteApiSocietaSocietaidSmtpConfigurationMutationKey = () =>
  [{ url: '/api/societa/:societaId/smtp-configuration' }] as const;

export type DeleteApiSocietaSocietaidSmtpConfigurationMutationKey = ReturnType<
  typeof deleteApiSocietaSocietaidSmtpConfigurationMutationKey
>;

/**
 * {@link /api/societa/:societaId/smtp-configuration}
 */
export async function deleteApiSocietaSocietaidSmtpConfiguration(
  societaId: DeleteApiSocietaSocietaidSmtpConfigurationPathParams['societaId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiSocietaSocietaidSmtpConfigurationMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'DELETE',
    url: `/api/societa/${societaId}/smtp-configuration`,
    ...requestConfig,
  });
  return deleteApiSocietaSocietaidSmtpConfigurationMutationResponseSchema.parse(
    res.data,
  );
}

/**
 * {@link /api/societa/:societaId/smtp-configuration}
 */
export function useDeleteApiSocietaSocietaidSmtpConfiguration<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiSocietaSocietaidSmtpConfigurationMutationResponse,
      ResponseErrorConfig<Error>,
      {
        societaId: DeleteApiSocietaSocietaidSmtpConfigurationPathParams['societaId'];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiSocietaSocietaidSmtpConfigurationMutationKey();

  return useMutation<
    DeleteApiSocietaSocietaidSmtpConfigurationMutationResponse,
    ResponseErrorConfig<Error>,
    {
      societaId: DeleteApiSocietaSocietaidSmtpConfigurationPathParams['societaId'];
    },
    TContext
  >(
    {
      mutationFn: async ({ societaId }) => {
        return deleteApiSocietaSocietaidSmtpConfiguration(societaId, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
